export const guideUrls = {
    mobileUserGuide: 'https://snchartnotifications.blob.core.windows.net/snchart/SurgicalNotesMobileAppUserGuide.pdf',
    userGuide: 'https://snchartnotifications.blob.core.windows.net/snchart/SNChartUserGuide.pdf',
    quickReferenceGuide: 'https://snchartnotifications.blob.core.windows.net/snchart/QuickReferenceGuide.pdf',
    esignDoc: 'https://snchartnotifications.blob.core.windows.net/snchart/E-SignatureForms.pdf'
}


// WEBPACK FOOTER //
// ./src/shared/guideUrls.js